import { defineStore } from 'pinia'
import { ref } from 'vue'
import { Handle } from '@/types'
import { useNotifyStore } from '@/stores/notifications'
import { uuid } from '@/composables'
import { z } from 'zod'

export const useHandlesStore = defineStore('handles', () => {
  const handles = ref<Handle[]>([])

  function setHandles(payload: Handle[]) {
    const validate = z.array(Handle).safeParse(payload)
    if (!validate.success) {
      const notifyStore = useNotifyStore()
      notifyStore.createNotify({
        id: uuid('v4'),
        alertType: 'error',
        title: 'Fehler',
        message: 'Ungültige Handle-Daten erhalten'
      })
      return
    }
    handles.value = payload
  }

  function addHandle(handle: Handle) {
    const validate = Handle.safeParse(handle)
    if (!validate.success) return
    handles.value = [...handles.value, handle]
  }

  function updateHandle(handle: Handle) {
    const validate = Handle.safeParse(handle)
    if (!validate.success) return
    handles.value = handles.value.map((h) => (h.id === handle.id ? handle : h))
  }

  function removeHandle(handleId: number) {
    handles.value = handles.value.filter((h) => h.id !== handleId)
  }

  function getHandles(): Handle[] {
    return handles.value
  }

  function getHandleById(id: number): Handle | undefined {
    return handles.value.find((h) => h.id === id)
  }

  return {
    handles,
    getHandles,
    setHandles,
    addHandle,
    updateHandle,
    removeHandle,
    getHandleById
  }
})
